import { Link } from "react-router-dom";

export function TermsCheckbox({ checked, onChange }) {
  return (
    <div className="mt-5 space-y-3">
      <div className="text-[11px] text-slate-400 space-y-1 border border-slate-800 rounded-md p-3 bg-slate-950/50" data-testid="checkout-disclosure">
        <p>One-time payment · no auto-renewal · prices in USD (charged in your selected currency at today's exchange rate), applicable taxes as shown.</p>
        <p>Digital product: generally non-refundable once delivered/activated — see <Link to="/refund-cancellation" target="_blank" className="text-[#03AB9E] underline">Refund &amp; Cancellation Policy</Link>.</p>
      </div>
      <label className="flex items-start gap-2.5 text-xs text-slate-300 cursor-pointer" data-testid="terms-checkbox-label">
        <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} data-testid="terms-checkbox" className="mt-0.5 h-4 w-4 accent-[#F58B23] shrink-0" />
        <span>I have read and agree to the CCMIntel <Link to="/subscription-terms" target="_blank" className="text-[#03AB9E] underline">Subscription Terms &amp; Conditions</Link> and <Link to="/privacy-policy" target="_blank" className="text-[#03AB9E] underline">Privacy Policy</Link>.</span>
      </label>
    </div>
  );
}
